import React from 'react';
import { lazy } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import Test from './Test.js';
import reportWebVitals from './reportWebVitals';
import './Test.css';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
    <Router>
    <Test />
    </Router>
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
